import { migrationProjectSelector } from '@store/migrationSelectors/projectSelectors'
import { artBoardActions } from '@store/reducers/artboard'
import { SocketActions } from '@store/socketSaga'
import { store } from '@store/store'
import { resetCommitState } from '@storeOld/middleware/commit'
import {
  NotificationType,
  notificationActionCreators,
} from '@storeOld/reducers/notification'
import { setSyncStatus } from '@storeOld/reducers/ui'
import { call } from 'redux-saga/effects'

import { reportClientEvent } from '@/services/clientEvents'
import { socket } from '../socket'
import { joinUserRoom } from './user'

// The app closing the socket itself (leaving the project) is not a drop.
const OWN_CLOSE_REASON = 'io client disconnect'

export function* init() {
  yield call(console.info, 'socket init')

  socket.open()

  socket.on('connect', () => {
    // A fresh connection is a fresh start for saving: the project is fetched
    // anew below, a commit refused before it no longer stands in the way.
    resetCommitState()
    store.dispatch(artBoardActions.setSaveFailed(false))
    store.dispatch(artBoardActions.setSocketOffline(false))

    store.dispatch(setSyncStatus('hidden'))

    // Only the OFFLINE toast is obsolete after a (re)connect — the rest of the
    // toasts (hints, AI progress) must survive it.
    store.dispatch(
      notificationActionCreators.setClearNotification({
        toastContainerId: 'socket',
      })
    )

    store.dispatch(SocketActions.updateProject())

    // rooms do not survive a reconnect; the project room is re-joined by
    // the collaboration hook, the user's own room here
    joinUserRoom()
  })

  socket.on('disconnect', (reason) => {
    if (reason !== OWN_CLOSE_REASON) {
      reportClientEvent({
        type: 'socket_disconnect',
        reason,
        projectId: migrationProjectSelector.getProjectId(store.getState()),
      })
    }

    store.dispatch(setSyncStatus('syncing'))

    store.dispatch(artBoardActions.setSocketOffline(true))
  })

  socket.io.on('reconnect_failed', () => {
    reportClientEvent({
      type: 'socket_reconnect_failed',
      projectId: migrationProjectSelector.getProjectId(store.getState()),
    })

    store.dispatch(
      notificationActionCreators.setSocketNotification({
        type: NotificationType.OFFLINE,
        callback: () => {
          // Deliberate full reload: the socket connection is beyond recovery
          // at this point, restarting the app is the safest way back (OCT-4772).
          window.location.reload()
        },
      })
    )

    store.dispatch(setSyncStatus('hidden'))
  })
}
